import { render, staticRenderFns } from "./OrderBody.vue?vue&type=template&id=dd69cb3c&scoped=true"
import script from "./OrderBody.vue?vue&type=script&lang=js"
export * from "./OrderBody.vue?vue&type=script&lang=js"
import style0 from "./OrderBody.vue?vue&type=style&index=0&id=dd69cb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd69cb3c",
  null
  
)

export default component.exports